import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddAddressInput = {
  address?: InputMaybe<AddressInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type AddProductsToCart = {
  cart?: Maybe<Cart>;
  userErrors?: Maybe<Array<Maybe<CartUserInputError>>>;
};

export type Address = {
  /** Town/City */
  city?: Maybe<Scalars['String']>;
  /** Company Name */
  company?: Maybe<Scalars['String']>;
  /** Country Code e.g. DE */
  country?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** Address Line 1 */
  line1?: Maybe<Scalars['String']>;
  /** Address Line 2 */
  line2?: Maybe<Scalars['String']>;
  /** Phone Number */
  phone?: Maybe<Scalars['String']>;
  /** State or Province or Region e.g. California (Can be null of stateCode is provided) */
  state?: Maybe<Scalars['String']>;
  /** State Code e.g. CA */
  stateCode?: Maybe<Scalars['String']>;
  /** VAT Number */
  vatNumber?: Maybe<Scalars['String']>;
  /** Postal/Zip Code */
  zip?: Maybe<Scalars['String']>;
};

export type AddressCountryResponse = {
  countries?: Maybe<Array<Maybe<Country>>>;
  countriesRequireState?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  freeShippingCountries?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  /** Town/City */
  city: Scalars['String'];
  /** Company Name */
  company?: InputMaybe<Scalars['String']>;
  /** Country Code e.g. DE */
  country: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Address Line 1 */
  line1: Scalars['String'];
  /** Address Line 2 */
  line2?: InputMaybe<Scalars['String']>;
  /** Phone Number */
  phone?: InputMaybe<Scalars['String']>;
  /** State or Province or Region e.g. California (Can be null of stateCode is provided) */
  state?: InputMaybe<Scalars['String']>;
  /** State Code e.g. CA */
  stateCode?: InputMaybe<Scalars['String']>;
  /** VAT Number */
  vatNumber?: InputMaybe<Scalars['String']>;
  /** Postal/Zip Code */
  zip: Scalars['String'];
};

export type AdyenPaymentMethod = {
  paymentMethodsExtraDetails?: Maybe<Array<Maybe<AdyenPaymentMethodsDetails>>>;
  paymentMethodsResponse?: Maybe<AdyenPaymentMethodsResponse>;
};

export type AdyenPaymentMethodConfiguration = {
  merchantId?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodDetailsItems = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodItem = {
  brand?: Maybe<Scalars['String']>;
  brands?: Maybe<Array<Maybe<Scalars['String']>>>;
  configuration?: Maybe<AdyenPaymentMethodConfiguration>;
  details?: Maybe<Array<Maybe<AdyenPaymentMethodItemDetails>>>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AdyenPaymentMethodItemDetails = {
  items?: Maybe<Array<Maybe<AdyenPaymentMethodDetailsItems>>>;
  key?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsDetails = {
  configuration?: Maybe<AdyenPaymentMethodsDetailsConfiguration>;
  icon?: Maybe<PaymentMethodIcon>;
  isOpenInvoice?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type AdyenPaymentMethodsDetailsConfiguration = {
  amount?: Maybe<AdyenPaymentMethodsMoney>;
  currency?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsMoney = {
  currency?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type AdyenPaymentMethodsResponse = {
  paymentMethods?: Maybe<Array<Maybe<AdyenPaymentMethodItem>>>;
  storedPaymentMethods?: Maybe<Array<Maybe<AdyenStoredPaymentMethods>>>;
};

export type AdyenPaymentStatus = {
  action?: Maybe<Scalars['String']>;
  additionalData?: Maybe<Scalars['String']>;
  isFinal?: Maybe<Scalars['Boolean']>;
  resultCode?: Maybe<Scalars['String']>;
};

export type AdyenStoredPaymentMethods = {
  brand?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  holderName?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  networkTxReference?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  shopperEmail?: Maybe<Scalars['String']>;
  supportedShopperInteractions?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type AppliedGiftCard = {
  appliedBalance: Price;
  code: Scalars['String'];
  currentBalance: Price;
  expirationDate?: Maybe<Scalars['String']>;
};

export type AppliedTax = {
  amount: Price;
  label: Scalars['String'];
};

export type Audio = {
  description?: Maybe<Scalars['String']>;
  file?: Maybe<AudioFile>;
  name?: Maybe<Scalars['String']>;
};

export type AudioFile = {
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type AvailablePaymentMethod = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type Banner = {
  blacklistUrl?: Maybe<Scalars['String']>;
  button1?: Maybe<Scalars['String']>;
  button2?: Maybe<Scalars['String']>;
  designOptionsBackground?: Maybe<Scalars['String']>;
  designOptionsTheme?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  whitelistUrl?: Maybe<Scalars['String']>;
};

export type BasePrice = {
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type BaseSavedPrice = {
  currency: Scalars['String'];
  percentage: Scalars['Float'];
  value: Scalars['Float'];
};

export type BundleProduct = ProductInterface & {
  additionalInformation?: Maybe<Scalars['String']>;
  audios?: Maybe<Array<Maybe<Audio>>>;
  brand?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  bundleItems: Array<BundleProductItem>;
  categories?: Maybe<Scalars['String']>;
  countryOfManufacture?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Image>;
  features?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isFree?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onSale: Scalars['Boolean'];
  overview?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  quickAddToCartSku?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  serialSystem?: Maybe<Scalars['String']>;
  serialSystemReferences?: Maybe<Scalars['String']>;
  shippable: Scalars['Boolean'];
  sku: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  smallImage?: Maybe<SmallImage>;
  stockStatus: StockStatus;
  systemRequirements?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Scalars['String']>;
  upids?: Maybe<Array<Maybe<Scalars['String']>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  whatIsIncluded?: Maybe<Scalars['String']>;
};

export type BundleProductItem = {
  name: Scalars['String'];
  options: Array<BundleProductItemOption>;
  price: ProductPrice;
  sku: Scalars['ID'];
};

export type BundleProductItemOption = {
  image?: Maybe<Image>;
  name: Scalars['String'];
  price: ProductPrice;
  sdbsId?: Maybe<Scalars['String']>;
  shippable: Scalars['Boolean'];
  sku: Scalars['ID'];
  stockStatus: StockStatus;
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type CacheKeysResponse = {
  keys: Array<Maybe<Scalars['String']>>;
};

export type CacheType =
  | 'all'
  | 'in_memory'
  | 'storage';

export type Cart = {
  appliedGiftCards?: Maybe<Array<Maybe<AppliedGiftCard>>>;
  availablePaymentMethods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  id: Scalars['ID'];
  isVirtual: Scalars['Boolean'];
  items?: Maybe<Array<Maybe<CartItem>>>;
  prices?: Maybe<CartPrices>;
  selectedPaymentMethod?: Maybe<SelectedPaymentMethod>;
};

export type CartItem = {
  id: Scalars['ID'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Int'];
};

export type CartItemInput = {
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type CartItemPrices = {
  price: Price;
  priceIncludingTax: Price;
  rowTotal: Price;
  rowTotalIncludingTax: Price;
};

export type CartPrices = {
  appliedTaxes?: Maybe<Array<Maybe<AppliedTax>>>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  grandTotal?: Maybe<Price>;
  subtotalExcludingTax?: Maybe<Price>;
  subtotalIncludingTax?: Maybe<Price>;
};

export type CartUserInputError = {
  code: CartUserInputErrorType;
  message: Scalars['String'];
};

export type CartUserInputErrorType =
  | 'INSUFFICIENT_STOCK'
  | 'NOT_SALABLE'
  | 'PERMISSION_DENIED'
  | 'PRODUCT_NOT_FOUND'
  | 'UNDEFINED';

export type CheckPlaceOrderStatus = {
  errors?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderIncrementId?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
};

export type ConfigurableProduct = ProductInterface & {
  additionalInformation?: Maybe<Scalars['String']>;
  audios?: Maybe<Array<Maybe<Audio>>>;
  brand?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  categories?: Maybe<Scalars['String']>;
  countryOfManufacture?: Maybe<Scalars['String']>;
  defaultVariant: ProductVariant;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Image>;
  features?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isFree?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  loyaltyVariant?: Maybe<ProductVariant>;
  manufacturer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onSale: Scalars['Boolean'];
  overview?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  quickAddToCartSku?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  serialSystem?: Maybe<Scalars['String']>;
  serialSystemReferences?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  smallImage?: Maybe<SmallImage>;
  stockStatus?: Maybe<StockStatus>;
  systemRequirements?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Scalars['String']>;
  upids?: Maybe<Array<Maybe<Scalars['String']>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  whatIsIncluded?: Maybe<Scalars['String']>;
};

export type Country = {
  availableRegions?: Maybe<Array<Maybe<Regions>>>;
  fullNameLocale?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  twoLetterAbbreviation?: Maybe<Scalars['String']>;
};

export type CreateCustomerInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateEmptyCartResponse = {
  cartId?: Maybe<Scalars['ID']>;
};

export type CurrentPlan = {
  id?: Maybe<Scalars['ID']>;
  itemPriceId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};

export type Customer = {
  address: Address;
  /** @deprecated Moved to address.company */
  company?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type CustomerCartIdResponse = {
  cartId?: Maybe<Scalars['ID']>;
};

export type DeleteCacheKeyResponse = {
  deletedKey?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Discount = {
  amount: Price;
  label: Scalars['String'];
};

export type DiscountPrice = {
  /** discounts applied to the final price */
  regularToFinal?: Maybe<BaseSavedPrice>;
  /** loyalty offers */
  regularToLoyalty?: Maybe<BaseSavedPrice>;
  /** amount saved compared to purchasing all items separately */
  totalBundleToFinal?: Maybe<BaseSavedPrice>;
};

export type EditSubscriptionResponse = {
  subscriptionPageUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GlobalCustomerOrder = {
  id: Scalars['ID'];
  paymentMethods?: Maybe<Array<OrderPaymentMethod>>;
};

export type GuestCartIdResponse = {
  cartId?: Maybe<Scalars['ID']>;
};

export type Image = {
  alternativeText?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  imageVariant?: Maybe<ImageVariant>;
  srcSet: Array<ImageVariant>;
  text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


export type ImageImageVariantArgs = {
  identifier: ImageVariantIdentifier;
};

export type ImageVariant = {
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImageVariantIdentifier =
  | 'GALLERY'
  | 'LARGE'
  | 'MEDIUM'
  | 'ORIGINAL'
  | 'REFERANCE'
  | 'SMALL'
  | 'TINY'
  | 'image_full_375w'
  | 'image_full_768w'
  | 'image_full_1024w'
  | 'image_full_1280w'
  | 'image_full_1920w';

export type Language =
  /** Deutsch */
  | 'de'
  /** English */
  | 'en'
  /** Español */
  | 'es'
  /** Français */
  | 'fr'
  /** Japanese [Correctly] */
  | 'ja'
  /** Japanese */
  | 'jp'
  /** Chinese */
  | 'zh';

export type LicenseCode =
  | 'COM_CRG'
  | 'COM_FUL'
  | 'COM_UPD'
  | 'COM_UPG'
  | 'None_None';

export type ManageSubscriptionUrlResponse = {
  subscriptionPageUrl?: Maybe<Scalars['String']>;
};

export type Menu = {
  draft: Scalars['Boolean'];
  menuItem?: Maybe<Array<Maybe<MenuItem>>>;
  menuKey: Scalars['String'];
  name: Scalars['String'];
};

export type MenuItem = {
  column1Links?: Maybe<Array<Maybe<MenuLink>>>;
  column2Links?: Maybe<Array<Maybe<MenuLink>>>;
  column3Links?: Maybe<Array<Maybe<MenuLink>>>;
  column22Links?: Maybe<Array<Maybe<MenuLink>>>;
  column23Links?: Maybe<Array<Maybe<MenuLink>>>;
  layout: Scalars['String'];
  name: Scalars['String'];
};

export type MenuLink = {
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  link?: Maybe<Scalars['String']>;
  theme: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type MergeCartsResponse = {
  cartId?: Maybe<Scalars['ID']>;
};

export type Mutation = {
  /**
   * Adds products to the cart.
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  addProductsToCart?: Maybe<AddProductsToCart>;
  /**
   * Applies gift card to the cart.
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  applyGiftCardToCart?: Maybe<Cart>;
  /**
   * Coupon code is validated and applied to subscription intent which is later applied to created subscription
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   */
  applySubscriptionCoupon?: Maybe<SubscriptionIntent>;
  /**
   * Cancel a subscription
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   */
  cancelSubscription: SubscriptionItem;
  /**
   * Creates susbscription customer record on chargebee (major identifier: `native_id`). If the customer already exists, the customer record is updated
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   * **Required Headers:**
   */
  createCustomer?: Maybe<Customer>;
  /**
   * Create an empty shopping cart for a guest or logged in user.
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  createEmptyCart?: Maybe<CreateEmptyCartResponse>;
  /**
   * Creates Payment Intent used as Subscription payment source for Paypal Integration
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   */
  createPaymentIntent?: Maybe<PaymentIntentResponse>;
  /**
   * Creates payment source for subscription customer. This payment source is used to associate customer to billing sources for subscription payment
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  createPaymentSource?: Maybe<PaymentSource>;
  /**
   * Creates susbscription for customer on chargebee and fulfil on NAPI
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  createSubscription?: Maybe<SubscriptionItem>;
  /**
   * Creates susbscription intent for custom checkout which is used after address and payment steps. The `id` returned from the result is used in the `createSubscription` mutation
   *
   * **Required Headers:**
   * - `store`: Store code e.g `ger_eur_en`
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  createSubscriptionIntent?: Maybe<SubscriptionIntent>;
  /**
   * Delete a specific cache object
   *
   * **Note:**
   * - `in_memory` and `storage` is purged in this case
   */
  deleteCacheKey?: Maybe<DeleteCacheKeyResponse>;
  /**
   * Transfer the contents of a guest cart into the cart of a logged-in customer.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  mergeCarts?: Maybe<MergeCartsResponse>;
  /**
   * Delete entire cache objects in the storage category specified
   *
   * **Note:**
   * - `in_memory`: Caches stored in memory -- auth configuration (also used in place of storage in local environment when redis is not available)
   * - `storage`: Caches stored `redis` -- All other cached objects
   * - `all`: Caches stored in both `redis` and `in_memory` -- All available storage types
   */
  purgeCache?: Maybe<PurgeCacheResponse>;
  /**
   * Reactivates a cancelled subscription
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   */
  reactivateSubscription: SubscriptionItem;
  /**
   * Place order.
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   * - `Authorization`: Authorized customer Bearer token
   */
  redirectAndPlaceOrder?: Maybe<RedirectAndPlaceOrderResponse>;
  /**
   * Removes applied gift card from the cart.
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  removeGiftCardFromCart?: Maybe<Cart>;
  /**
   * Sets payment method on cart.
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   * - `Authorization`: Authorized customer Bearer token
   */
  setPaymentMethodOnCart?: Maybe<Cart>;
  /**
   * Updates existing subscription customer address [billing address]
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  updateAddress?: Maybe<Customer>;
};


export type MutationAddProductsToCartArgs = {
  cartId: Scalars['ID'];
  cartItems: Array<CartItemInput>;
};


export type MutationApplyGiftCardToCartArgs = {
  cartId: Scalars['ID'];
  giftCardCode: Scalars['String'];
};


export type MutationApplySubscriptionCouponArgs = {
  couponCode: Scalars['String'];
  subscriptionIntentId: Scalars['ID'];
};


export type MutationCancelSubscriptionArgs = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  extraComment?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['Int'];
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreatePaymentIntentArgs = {
  amount: Scalars['Int'];
  paymentMethodType: PaymentMethodType;
  subscriptionIntentId: Scalars['ID'];
};


export type MutationCreatePaymentSourceArgs = {
  isUpdate?: InputMaybe<Scalars['Boolean']>;
  subscriptionIntentId: Scalars['ID'];
  token: Scalars['String'];
  type: PaymentSourceType;
};


export type MutationCreateSubscriptionArgs = {
  subscriptionIntentId: Scalars['ID'];
};


export type MutationCreateSubscriptionIntentArgs = {
  itemPriceId: Scalars['ID'];
  licensedProductId: Scalars['Int'];
};


export type MutationDeleteCacheKeyArgs = {
  key: Scalars['String'];
};


export type MutationMergeCartsArgs = {
  destinationId: Scalars['ID'];
  sourceId: Scalars['ID'];
};


export type MutationPurgeCacheArgs = {
  type: CacheType;
  withConfig?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReactivateSubscriptionArgs = {
  itemPriceId: Scalars['ID'];
  subscriptionId: Scalars['Int'];
};


export type MutationRedirectAndPlaceOrderArgs = {
  input: RedirectAndPlaceOrderInput;
};


export type MutationRemoveGiftCardFromCartArgs = {
  cartId: Scalars['ID'];
  giftCardCode: Scalars['String'];
};


export type MutationSetPaymentMethodOnCartArgs = {
  cartId: Scalars['ID'];
  stateData: Scalars['String'];
};


export type MutationUpdateAddressArgs = {
  input: AddAddressInput;
  subscriptionIntentId?: InputMaybe<Scalars['ID']>;
};

export type OfferType =
  | 'BEST_VALUE'
  | 'CURRENT_PLAN'
  | 'MOST_POPULAR'
  | 'NONE';

export type OrderPaymentMethod = {
  name: Scalars['String'];
  type: Scalars['String'];
};

export type PackageType =
  | 'BOX'
  | 'DL'
  | 'NONE';

export type PaymentIntent = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PaymentIntentRaw = {
  amount?: Maybe<Scalars['Float']>;
  business_entity_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Int']>;
  currency_code?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Int']>;
  gateway?: Maybe<Scalars['String']>;
  gateway_account_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  modified_at?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  payment_method_type?: Maybe<Scalars['String']>;
  resource_version?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Int']>;
};

export type PaymentIntentResponse = {
  /** Minimized data Payment Intent data */
  paymentIntent?: Maybe<PaymentIntent>;
  /** Raw Payment Intent data needed for Paypal Integration using ChargebeeJs */
  paymentIntentRaw?: Maybe<PaymentIntentRaw>;
};

export type PaymentMethodIcon = {
  height?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type PaymentMethodType =
  | 'APPLE_PAY'
  | 'CARD'
  | 'DIRECT_DEBIT'
  | 'GOOGLE_PAY'
  | 'PAYPAL';

export type PaymentSource = {
  card?: Maybe<PaymentSourceCard>;
  createdAt?: Maybe<Scalars['Int']>;
  customerId?: Maybe<Scalars['String']>;
  gateway?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type PaymentSourceCard = {
  brand?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['Int']>;
  expiryYear?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
  maskedNumber?: Maybe<Scalars['String']>;
};

export type PaymentSourceType =
  | 'CHARGEBEE_TOKEN'
  | 'TEMPORARY_TOKEN';

export type PeriodUnit =
  | 'DAY'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

export type PlanStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DELETED';

export type Price = {
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type ProductDetailPage = {
  historySlugs: Array<Scalars['String']>;
  linkedProductDetailPages?: Maybe<Array<ProductDetailPage>>;
  product: ProductInterface;
  published: Scalars['Boolean'];
  seoCanonical: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  showRetailerLink: Scalars['Boolean'];
  slug: Scalars['String'];
  tags?: Maybe<Array<Tag>>;
};

export type ProductDownload = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ProductDownloadDetail = {
  downloadLink: Scalars['String'];
  fileSize: Scalars['String'];
  id: Scalars['ID'];
  maxOsVersion?: Maybe<Scalars['String']>;
  minOsVersion?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  releaseDate: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type ProductInterface = {
  additionalInformation?: Maybe<Scalars['String']>;
  audios?: Maybe<Array<Maybe<Audio>>>;
  brand?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  categories?: Maybe<Scalars['String']>;
  countryOfManufacture?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Image>;
  features?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isFree?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onSale: Scalars['Boolean'];
  overview?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  quickAddToCartSku?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  serialSystem?: Maybe<Scalars['String']>;
  serialSystemReferences?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  smallImage?: Maybe<SmallImage>;
  stockStatus?: Maybe<StockStatus>;
  systemRequirements?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Scalars['String']>;
  upids?: Maybe<Array<Maybe<Scalars['String']>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  whatIsIncluded?: Maybe<Scalars['String']>;
};

export type ProductPrice = {
  /** normal or discounted price of the full version */
  final: BasePrice;
  /** best price for a loyalty customer (update, upgrade, crossgrade) */
  loyalty?: Maybe<BasePrice>;
  /** Used for strike-through price cases */
  regular: BasePrice;
  /** discount computed prices */
  savings?: Maybe<DiscountPrice>;
  /** total price of all items in the bundle */
  totalBundle?: Maybe<BasePrice>;
};

export type ProductType =
  | 'BundleProduct'
  | 'ConfigurableProduct'
  | 'VirtualProduct';

export type ProductVariant = {
  attributes?: Maybe<Array<Maybe<VariantAttributes>>>;
  image?: Maybe<Image>;
  itemType?: Maybe<Scalars['Int']>;
  licenseClass?: Maybe<Scalars['Int']>;
  licenseLabel: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  onSale: Scalars['Boolean'];
  ownedByUser?: Maybe<Scalars['Boolean']>;
  price: ProductPrice;
  relatedOwnedProductName?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  sdbsId?: Maybe<Scalars['String']>;
  serialSystemReference?: Maybe<Scalars['String']>;
  shippable: Scalars['Boolean'];
  sku: Scalars['ID'];
  stockStatus: StockStatus;
};

export type PurgeCacheResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type Query = {
  /**
   * Gets country list with regions/states, including countries where region/state is required in address
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  addressCountry?: Maybe<AddressCountryResponse>;
  /**
   * Gets Adyen Payment Methods
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  adyenPaymentMethods?: Maybe<AdyenPaymentMethod>;
  /**
   * Checks Adyen Payment status
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   * - `Authorization`: Authorized customer Bearer token
   */
  adyenPaymentStatus?: Maybe<AdyenPaymentStatus>;
  banner?: Maybe<Banner>;
  cacheKeys?: Maybe<CacheKeysResponse>;
  /**
   * Checks Place Order status
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   * - `Authorization`: Authorized customer Bearer token
   */
  checkPlaceOrderStatus?: Maybe<CheckPlaceOrderStatus>;
  /**
   * Gets store related data
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  countryStoreCode?: Maybe<ShopStore>;
  /**
   * Get a single customer address
   *
   * ##Parameters
   * - `country`: (Deprecated) Send x-country header instead.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  customerAddress?: Maybe<Address>;
  /**
   * Return the customer cart data.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  customerCart?: Maybe<Cart>;
  /**
   * Return the customer cart id.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  customerCartId?: Maybe<CustomerCartIdResponse>;
  /**
   * Get URL to manage subscription on hosted checkout
   *
   * **Parameters**
   * - `priceId`: Item price id.
   * - `productId`: Licence product Id
   * - `language`: (Deprecated) Send x-language header instead.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  editSubscription?: Maybe<EditSubscriptionResponse>;
  /**
   * Gets free shipping countries
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  freeShippingCountries?: Maybe<Scalars['String']>;
  /**
   * Return customer global orders.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  globalCustomerOrders?: Maybe<Array<GlobalCustomerOrder>>;
  /**
   * Return the guest cart id.
   *
   * **Required Parameters:**
   * - `cartId`: The guest cart id.
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  guestCartId?: Maybe<GuestCartIdResponse>;
  /**
   * Get URL to manage subscription on hosted checkout
   *
   * **Parameters**
   * - `language`: (Deprecated) Send x-language header instead.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  manageSubscriptionUrl?: Maybe<ManageSubscriptionUrlResponse>;
  me?: Maybe<User>;
  /**
   * Fetch menu by menu-key.
   *
   * **Parameters**
   * - `menuKey`: menu menu-key.
   *
   * **Required Headers:**
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  menu?: Maybe<Menu>;
  /**
   * Fetch a single subscription plan
   *
   * **Parameters**
   * - `ids`: List of plan IDs.
   * - `language`: (Deprecated) Send x-language header instead.
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  plan?: Maybe<SubscriptionPlan>;
  /**
   * Fetch multiple subscription plans
   *
   * **Parameters**
   * - `ids`: List of plan IDs.
   * - `language`: (Deprecated) Send x-language header instead.
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  plans?: Maybe<Array<Maybe<SubscriptionPlan>>>;
  /**
   * Fetch catalog products by their ID - SKU.
   *
   * **Parameters**
   * - `sku`: Product SKU.
   *
   * **Required Headers:**
   * - `Authorization`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  product?: Maybe<ProductInterface>;
  /**
   * This query fetch all the data needed to all elements displayed in the product detail page.
   *
   * **Parameters**
   * - `slug`: Product Detail Page slug.
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  productDetailPage?: Maybe<ProductDetailPage>;
  productDownloadDetails: Array<ProductDownloadDetail>;
  productDownloads: Array<ProductDownload>;
  /**
   * Fetch catalog products by their SKUs or Slugs.
   *
   * **Parameters**
   * - `skus`: Optional array of product SKU.
   *
   * **Required Headers:**
   * - `Authorization`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  products: Array<ProductInterface>;
  /**
   * Gets store config data
   *
   * **Required Headers:**
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  storeConfig?: Maybe<StoreConfig>;
  /**
   * Fetch a single subscription data belonging to a customer
   *
   * **Parameters**
   * - `ID`: subscription ID.
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  subscription?: Maybe<SubscriptionItem>;
  subscriptionCancellationReasons?: Maybe<Array<Maybe<SubscriptionCancellationReasons>>>;
  /**
   * Get subscription intent data
   *
   * **Parameters**
   * - `id`: subscription intent id
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  subscriptionIntent?: Maybe<SubscriptionIntent>;
  /**
   * Fetch multiple subscriptions belonging to a customer
   *
   * **Required Headers:**
   * - `Authorization`: Authorized customer Bearer token
   * - `x-country`: Two-digit country code e.g `NG` `DE` `US` `GB` `GH`
   * - `x-language`: Two-digit language code e.g `en` `de` `ja` `fr` `es` `zh`
   */
  subscriptions?: Maybe<Array<Maybe<SubscriptionItem>>>;
  /**
   * A Translation represents a single string in particular language
   * **Required Parameters:**
   * - `language`: The language of the target translation.
   * - `section`: The translation localize section.
   * **Optional Parameters:**
   * - `keys`: Filter some of the resulted translation keys.
   */
  translations?: Maybe<Array<Maybe<Translation>>>;
};


export type QueryAdyenPaymentMethodsArgs = {
  cartId: Scalars['ID'];
};


export type QueryAdyenPaymentStatusArgs = {
  cartId: Scalars['ID'];
  orderNumber: Scalars['String'];
};


export type QueryCacheKeysArgs = {
  type: CacheType;
};


export type QueryCheckPlaceOrderStatusArgs = {
  cartId: Scalars['ID'];
};


export type QueryCustomerAddressArgs = {
  country?: InputMaybe<Scalars['String']>;
};


export type QueryEditSubscriptionArgs = {
  priceId: Scalars['ID'];
  productId: Scalars['Int'];
};


export type QueryGlobalCustomerOrdersArgs = {
  isVirtualCart?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGuestCartIdArgs = {
  cartId: Scalars['ID'];
};


export type QueryManageSubscriptionUrlArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type QueryMenuArgs = {
  menuKey: Scalars['String'];
};


export type QueryPlanArgs = {
  id: Scalars['ID'];
  language?: InputMaybe<Language>;
};


export type QueryPlansArgs = {
  ids: Array<Scalars['ID']>;
  language?: InputMaybe<Language>;
};


export type QueryProductArgs = {
  sku: Scalars['ID'];
};


export type QueryProductDetailPageArgs = {
  slug: Scalars['String'];
};


export type QueryProductDownloadDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  skus?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySubscriptionArgs = {
  ID: Scalars['ID'];
};


export type QuerySubscriptionIntentArgs = {
  id: Scalars['ID'];
};


export type QueryTranslationsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language: Language;
  section: Scalars['String'];
};

export type RedirectAndPlaceOrderInput = {
  cartId: Scalars['ID'];
  failedUrl: Scalars['String'];
  origin: Scalars['String'];
  returnUrl: Scalars['String'];
  successUrl: Scalars['String'];
};

export type RedirectAndPlaceOrderResponse = {
  payRedirectUrl?: Maybe<Scalars['String']>;
};

export type Regions = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** This is only for test purposes - WILL BE REMOVED BEFORE PROD once NAPI is ready for Eligibility Chech */
export type ResponseScenario =
  | 'DOWNGRADE'
  | 'NEW'
  | 'PARENT_PRODUCT_NOT_OWNED'
  | 'PRODUCT_EXISTS'
  | 'UPGRADE';

export type SelectedPaymentMethod = {
  code?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ShopStore = {
  currency?: Maybe<Scalars['String']>;
  storeCode?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['ID']>;
};

export type SimpleProduct = ProductInterface & {
  additionalInformation?: Maybe<Scalars['String']>;
  audios?: Maybe<Array<Maybe<Audio>>>;
  brand?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  categories?: Maybe<Scalars['String']>;
  countryOfManufacture?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Image>;
  features?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isFree?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onSale: Scalars['Boolean'];
  overview?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  quickAddToCartSku?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  sdbsId?: Maybe<Scalars['String']>;
  serialSystem?: Maybe<Scalars['String']>;
  serialSystemReferences?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  smallImage?: Maybe<SmallImage>;
  stockStatus?: Maybe<StockStatus>;
  systemRequirements?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Scalars['String']>;
  upids?: Maybe<Array<Maybe<Scalars['String']>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  whatIsIncluded?: Maybe<Scalars['String']>;
};

export type SmallImage = {
  url: Scalars['String'];
};

export type Status =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'DELETED'
  | 'ERROR'
  | 'NON_RENEWING'
  | 'PAUSED'
  | 'TRIAL';

export type StockStatus =
  | 'IN_STOCK'
  | 'OUT_OF_STOCK';

export type StoreConfig = {
  currency: Scalars['String'];
  storeCode: Scalars['String'];
  storeId: Scalars['ID'];
  taxSalesDisplayPrice: Scalars['String'];
  taxSalesDisplaySubtotal: Scalars['String'];
};

export type SubscriptionActionType =
  | 'DOWNGRADE'
  | 'NEW'
  | 'UPGRADE';

export type SubscriptionCancellationReasons = {
  displayName?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  reasonCode?: Maybe<Scalars['String']>;
};

export type SubscriptionCard = {
  brand?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['Int']>;
  expiryYear?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  last4?: Maybe<Scalars['String']>;
  maskedNumber?: Maybe<Scalars['String']>;
};

export type SubscriptionCoupon = {
  code?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  includeTrialPeriod?: Maybe<Scalars['Boolean']>;
  period?: Maybe<Scalars['Int']>;
  periodUnit?: Maybe<PeriodUnit>;
};

export type SubscriptionIntent = {
  actionType: SubscriptionActionType;
  activatedAt?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  amount: Scalars['Float'];
  billingPeriod?: Maybe<Scalars['Int']>;
  billingPeriodUnit?: Maybe<PeriodUnit>;
  card?: Maybe<PaymentSourceCard>;
  coupon?: Maybe<SubscriptionCoupon>;
  couponApplied?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  currentPlan?: Maybe<CurrentPlan>;
  currentTermEnd?: Maybe<Scalars['String']>;
  currentTermStart?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  deleted?: Maybe<Scalars['Boolean']>;
  dueInvoicesCount?: Maybe<Scalars['Int']>;
  dueSince?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  itemPriceId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextBillingAt?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['ID']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  paymentSourceId?: Maybe<Scalars['ID']>;
  planId: Scalars['ID'];
  remainingBillingCycles?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['ID']>;
  totalDues?: Maybe<Scalars['Int']>;
  trialPeriod?: Maybe<Scalars['Int']>;
  trialPeriodUnit?: Maybe<PeriodUnit>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SubscriptionItem = {
  address?: Maybe<Address>;
  amount?: Maybe<Scalars['Float']>;
  billingPeriod?: Maybe<Scalars['Int']>;
  billingPeriodUnit?: Maybe<PeriodUnit>;
  canReactivate: Scalars['Boolean'];
  cancellationId: Scalars['Int'];
  cancellationScheduledAt?: Maybe<Scalars['String']>;
  card?: Maybe<SubscriptionCard>;
  coupon?: Maybe<SubscriptionCoupon>;
  couponApplied?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  currentTermEnd?: Maybe<Scalars['String']>;
  currentTermStart?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  dueInvoicesCount?: Maybe<Scalars['Int']>;
  dueSince?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['String']>;
  hasScheduledChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  itemPriceId: Scalars['ID'];
  mrr?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nextBillingAt?: Maybe<Scalars['String']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  planStatus?: Maybe<PlanStatus>;
  relatedPlans?: Maybe<Array<Maybe<SubscriptionPlan>>>;
  remainingBillingCycles?: Maybe<Scalars['Int']>;
  resourceVersion?: Maybe<Scalars['ID']>;
  startedAt?: Maybe<Scalars['String']>;
  status: Status;
  totalDues?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SubscriptionPlan = {
  description: Scalars['String'];
  enabledForCheckout: Scalars['Boolean'];
  family: Scalars['String'];
  features: Array<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use offerType instead */
  is_best_value: Scalars['Boolean'];
  /** @deprecated Use offerType instead */
  is_current_plan?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use offerType instead */
  is_most_popular: Scalars['Boolean'];
  licensedProductId: Scalars['Int'];
  name: Scalars['String'];
  offerType: OfferType;
  prices?: Maybe<Array<SubscriptionPlanPrice>>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<SubscriptionPlanStatus>;
  systemName: Scalars['String'];
  yearMonthPrice?: Maybe<YearMonthPrice>;
  /** @deprecated Use yearMonthPrice instead */
  yearMonthPriceDifference: Scalars['Float'];
};


export type SubscriptionPlanPricesArgs = {
  currencyCode?: InputMaybe<Scalars['String']>;
};

export type SubscriptionPlanPrice = {
  currency: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  period: Scalars['Int'];
  periodUnit: PeriodUnit;
  price: Scalars['Float'];
  systemName: Scalars['String'];
  trialPeriod?: Maybe<Scalars['Int']>;
  trialPeriodUnit?: Maybe<PeriodUnit>;
};

export type SubscriptionPlanStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DELETED';

export type SubscriptionUpdateStatuses =
  | 'active'
  | 'cancel';

export type Tag = {
  name: Scalars['String'];
};

export type Translation = {
  /** The unique key which identifies the string */
  key?: Maybe<Scalars['String']>;
  /** The translated string */
  value?: Maybe<Scalars['String']>;
};

/** user information of the authenticated user */
export type User = {
  country?: Maybe<Scalars['String']>;
  ecommerceStatus?: Maybe<Scalars['String']>;
  /** main email address of the authenticated user */
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  /** izo id of the authenticated user */
  izoId: Scalars['ID'];
  language: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  licenseIDs: Array<Scalars['String']>;
  /** native id of the authenticated user */
  nativeId: Scalars['ID'];
  userId: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type VariantAttributes = {
  adminLabel?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type Video = {
  autoplay?: Maybe<Scalars['Boolean']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  loop?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
  posterImage?: Maybe<Image>;
  text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type VirtualProduct = ProductInterface & {
  additionalInformation?: Maybe<Scalars['String']>;
  audios?: Maybe<Array<Maybe<Audio>>>;
  brand?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  categories?: Maybe<Scalars['String']>;
  countryOfManufacture?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Image>;
  features?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isFree?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onSale: Scalars['Boolean'];
  overview?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  quickAddToCartSku?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  sdbsId?: Maybe<Scalars['String']>;
  serialSystem?: Maybe<Scalars['String']>;
  serialSystemReferences?: Maybe<Scalars['String']>;
  shippable: Scalars['Boolean'];
  sku: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  smallImage?: Maybe<SmallImage>;
  stockStatus?: Maybe<StockStatus>;
  systemRequirements?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Scalars['String']>;
  upids?: Maybe<Array<Maybe<Scalars['String']>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  whatIsIncluded?: Maybe<Scalars['String']>;
};

export type YearMonthPrice = {
  /** Amount saved when yearly price is selected as offset from regular monthly price */
  amountSaved: Scalars['Float'];
  /** Monthly price calculated from yearly price */
  monthlyPrice: Scalars['Float'];
  /** Percentage saved when yearly price is selected compared to regular monthly price */
  percentSaved: Scalars['Float'];
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { email: string, izoId: string, nativeId: string, ecommerceStatus?: string | null } | null };

export type ProductDownloadsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductDownloadsQuery = { productDownloads: Array<{ id: string, title: string }> };

export type ProductDownloadDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductDownloadDetailsQuery = { productDownloadDetails: Array<{ downloadLink: string, fileSize: string, id: string, maxOsVersion?: string | null, minOsVersion?: string | null, platform: string, releaseDate: string, title: string, version: string }> };

export type SubscriptionInfoFragment = { id: string, name: string, cancellationId: number, status: Status, createdAt?: string | null, startedAt?: string | null, updatedAt?: string | null, endAt?: string | null, expiresIn?: string | null, canReactivate: boolean, cancellationScheduledAt?: string | null, itemPriceId: string, coupon?: { code?: string | null, period?: number | null, periodUnit?: PeriodUnit | null } | null };

export type UserSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSubscriptionsQuery = { me?: { email: string, nativeId: string } | null, subscriptions?: Array<SubscriptionInfoFragment | null> | null };

export type CancellationReasonsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancellationReasonsQuery = { subscription?: { id: string, cancellationId: number, endAt?: string | null } | null, subscriptionCancellationReasons?: Array<{ displayName?: string | null, reasonCode?: string | null, orderId?: number | null } | null> | null };

export type CancelSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int'];
  cancellationReason: Scalars['String'];
  extraComment: Scalars['String'];
}>;


export type CancelSubscriptionMutation = { cancelSubscription: { id: string, status: Status } };

export type ReactivateSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int'];
  itemPriceId: Scalars['ID'];
}>;


export type ReactivateSubscriptionMutation = { reactivateSubscription: { id: string, status: Status } };

export type CustomerAddressQueryVariables = Exact<{
  country: Scalars['String'];
}>;


export type CustomerAddressQuery = { customerAddress?: { firstName?: string | null, lastName?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, city?: string | null, state?: string | null, stateCode?: string | null, country?: string | null, phone?: string | null, company?: string | null } | null };

export type AddressCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type AddressCountryQuery = { addressCountry?: { countriesRequireState?: string | null, countries?: Array<{ id?: string | null, twoLetterAbbreviation?: string | null, fullNameLocale?: string | null, availableRegions?: Array<{ id?: number | null, name?: string | null, code?: string | null } | null> | null } | null> | null } | null };

export type UpdateCustomerAddressMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  zip: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  subscriptionIntentId: Scalars['ID'];
}>;


export type UpdateCustomerAddressMutation = { updateAddress?: { id: string, email: string, firstName: string, lastName: string, address: { line1?: string | null, zip?: string | null, city?: string | null, country?: string | null, stateCode?: string | null, state?: string | null, company?: string | null } } | null };

export type CreateSubscriptionCustomerMutationVariables = Exact<{
  language: Language;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  zip: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
}>;


export type CreateSubscriptionCustomerMutation = { createCustomer?: { id: string, email: string, firstName: string, lastName: string, address: { line1?: string | null, zip?: string | null, city?: string | null, country?: string | null, stateCode?: string | null, state?: string | null, company?: string | null } } | null };

export type GetSubscriptionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSubscriptionQuery = { subscription?: { __typename: 'SubscriptionItem', status: Status, id: string, itemPriceId: string, name: string, amount?: number | null, currencyCode: string, customerId?: string | null, billingPeriodUnit?: PeriodUnit | null, billingPeriod?: number | null, currentTermStart?: string | null, currentTermEnd?: string | null, dueSince?: string | null, dueInvoicesCount?: number | null, nextBillingAt?: string | null, paymentMethodType?: PaymentMethodType | null, createdAt?: string | null, canReactivate: boolean, cancellationId: number, deleted: boolean, hasScheduledChanges: boolean, coupon?: { code?: string | null, period?: number | null, periodUnit?: PeriodUnit | null } | null } | null };

export type ApplyCouponMutationVariables = Exact<{
  subscriptionIntentId: Scalars['ID'];
  couponCode: Scalars['String'];
}>;


export type ApplyCouponMutation = { applySubscriptionCoupon?: { id: string, actionType: SubscriptionActionType, activatedAt?: string | null, couponApplied?: boolean | null, coupon?: { code?: string | null, periodUnit?: PeriodUnit | null, period?: number | null, includeTrialPeriod?: boolean | null, discountPercentage?: number | null } | null } | null };

export type CreatePaymentIntentMutationVariables = Exact<{
  amount: Scalars['Int'];
  subscriptionIntentId: Scalars['ID'];
  paymentMethodType: PaymentMethodType;
}>;


export type CreatePaymentIntentMutation = { createPaymentIntent?: { paymentIntent?: { id?: string | null, status?: string | null, amount?: number | null, currencyCode?: string | null, expiresAt?: string | null, paymentMethodType?: string | null } | null, paymentIntentRaw?: { id?: string | null, status?: string | null, amount?: number | null, gateway_account_id?: string | null, expires_at?: number | null, payment_method_type?: string | null, created_at?: number | null, modified_at?: number | null, updated_at?: number | null, resource_version?: string | null, object?: string | null, customer_id?: string | null, currency_code?: string | null, gateway?: string | null, business_entity_id?: string | null } | null } | null };

export type CreateSubscriptionMutationVariables = Exact<{
  subscriptionIntentId: Scalars['ID'];
}>;


export type CreateSubscriptionMutation = { createSubscription?: { id: string, name: string, amount?: number | null, currencyCode: string, billingPeriodUnit?: PeriodUnit | null, currentTermEnd?: string | null, currentTermStart?: string | null, remainingBillingCycles?: number | null, createdAt?: string | null, startedAt?: string | null, updatedAt?: string | null, status: Status, totalDues?: number | null, deleted: boolean, dueSince?: string | null, dueInvoicesCount?: number | null, nextBillingAt?: string | null, paymentMethodType?: PaymentMethodType | null, card?: { brand?: string | null, expiryMonth?: number | null, expiryYear?: number | null, last4?: string | null, maskedNumber?: string | null } | null, address?: { firstName?: string | null, lastName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, stateCode?: string | null, state?: string | null, zip?: string | null, country?: string | null, vatNumber?: string | null, company?: string | null, phone?: string | null } | null } | null };

export type CreateSubscriptionIntentMutationVariables = Exact<{
  itemPriceId: Scalars['ID'];
  licensedProductId: Scalars['Int'];
}>;


export type CreateSubscriptionIntentMutation = { createSubscriptionIntent?: { id: string, actionType: SubscriptionActionType, name?: string | null, amount: number, currencyCode: string, billingPeriodUnit?: PeriodUnit | null, trialPeriod?: number | null, planId: string, currentTermEnd?: string | null, currentTermStart?: string | null, remainingBillingCycles?: number | null, createdAt?: string | null, startedAt?: string | null, updatedAt?: string | null, status?: string | null, totalDues?: number | null, deleted?: boolean | null, dueSince?: string | null, dueInvoicesCount?: number | null, nextBillingAt?: string | null, card?: { brand?: string | null, expiryMonth?: number | null, expiryYear?: number | null, last4?: string | null, maskedNumber?: string | null } | null, address?: { firstName?: string | null, lastName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, stateCode?: string | null, state?: string | null, zip?: string | null, country?: string | null, vatNumber?: string | null, company?: string | null, phone?: string | null } | null } | null };

export type GetSubscriptionIntentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSubscriptionIntentQuery = { subscriptionIntent?: { id: string, actionType: SubscriptionActionType, name?: string | null, amount: number, currencyCode: string, customerId: string, billingPeriodUnit?: PeriodUnit | null, billingPeriod?: number | null, trialPeriod?: number | null, trialPeriodUnit?: PeriodUnit | null, planId: string, image?: string | null, currentTermEnd?: string | null, currentTermStart?: string | null, remainingBillingCycles?: number | null, createdAt?: string | null, startedAt?: string | null, updatedAt?: string | null, status?: string | null, totalDues?: number | null, deleted?: boolean | null, dueSince?: string | null, dueInvoicesCount?: number | null, nextBillingAt?: string | null, subscriptionId?: string | null, paymentIntentId?: string | null, paymentMethodType?: PaymentMethodType | null, paymentSourceId?: string | null, coupon?: { code?: string | null, discountPercentage?: number | null, period?: number | null, periodUnit?: PeriodUnit | null, includeTrialPeriod?: boolean | null } | null, card?: { brand?: string | null, expiryMonth?: number | null, expiryYear?: number | null, last4?: string | null, maskedNumber?: string | null } | null, address?: { firstName?: string | null, lastName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, stateCode?: string | null, state?: string | null, zip?: string | null, country?: string | null, vatNumber?: string | null, company?: string | null, phone?: string | null } | null } | null };

export type RelatedPlansQueryVariables = Exact<{
  subscriptionId: Scalars['ID'];
}>;


export type RelatedPlansQuery = { subscription?: { id: string, billingPeriodUnit?: PeriodUnit | null, address?: { country?: string | null } | null, relatedPlans?: Array<{ id: string, name: string, family: string, licensedProductId: number, enabledForCheckout: boolean, sku?: string | null, systemName: string, description: string, status?: SubscriptionPlanStatus | null, features: Array<string>, offerType: OfferType, yearMonthPrice?: { monthlyPrice: number, percentSaved: number, amountSaved: number } | null, prices?: Array<{ name: string, id: string, period: number, periodUnit: PeriodUnit, price: number, systemName: string, currency: string }> | null } | null> | null } | null };

export const SubscriptionInfoFragmentDoc = gql`
    fragment subscriptionInfo on SubscriptionItem {
  id
  name
  cancellationId
  status
  createdAt
  startedAt
  updatedAt
  endAt
  expiresIn
  canReactivate
  cancellationScheduledAt
  itemPriceId
  coupon {
    code
    period
    periodUnit
  }
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    email
    izoId
    nativeId
    ecommerceStatus
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ProductDownloadsDocument = gql`
    query productDownloads {
  productDownloads {
    id
    title
  }
}
    `;

/**
 * __useProductDownloadsQuery__
 *
 * To run a query within a React component, call `useProductDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDownloadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductDownloadsQuery(baseOptions?: Apollo.QueryHookOptions<ProductDownloadsQuery, ProductDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDownloadsQuery, ProductDownloadsQueryVariables>(ProductDownloadsDocument, options);
      }
export function useProductDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDownloadsQuery, ProductDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDownloadsQuery, ProductDownloadsQueryVariables>(ProductDownloadsDocument, options);
        }
export type ProductDownloadsQueryHookResult = ReturnType<typeof useProductDownloadsQuery>;
export type ProductDownloadsLazyQueryHookResult = ReturnType<typeof useProductDownloadsLazyQuery>;
export type ProductDownloadsQueryResult = Apollo.QueryResult<ProductDownloadsQuery, ProductDownloadsQueryVariables>;
export const ProductDownloadDetailsDocument = gql`
    query productDownloadDetails($id: ID!) {
  productDownloadDetails(id: $id) {
    downloadLink
    fileSize
    id
    maxOsVersion
    minOsVersion
    platform
    releaseDate
    title
    version
  }
}
    `;

/**
 * __useProductDownloadDetailsQuery__
 *
 * To run a query within a React component, call `useProductDownloadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDownloadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDownloadDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductDownloadDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductDownloadDetailsQuery, ProductDownloadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDownloadDetailsQuery, ProductDownloadDetailsQueryVariables>(ProductDownloadDetailsDocument, options);
      }
export function useProductDownloadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDownloadDetailsQuery, ProductDownloadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDownloadDetailsQuery, ProductDownloadDetailsQueryVariables>(ProductDownloadDetailsDocument, options);
        }
export type ProductDownloadDetailsQueryHookResult = ReturnType<typeof useProductDownloadDetailsQuery>;
export type ProductDownloadDetailsLazyQueryHookResult = ReturnType<typeof useProductDownloadDetailsLazyQuery>;
export type ProductDownloadDetailsQueryResult = Apollo.QueryResult<ProductDownloadDetailsQuery, ProductDownloadDetailsQueryVariables>;
export const UserSubscriptionsDocument = gql`
    query userSubscriptions {
  me {
    email
    nativeId
  }
  subscriptions {
    ...subscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useUserSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>(UserSubscriptionsDocument, options);
      }
export function useUserSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>(UserSubscriptionsDocument, options);
        }
export type UserSubscriptionsQueryHookResult = ReturnType<typeof useUserSubscriptionsQuery>;
export type UserSubscriptionsLazyQueryHookResult = ReturnType<typeof useUserSubscriptionsLazyQuery>;
export type UserSubscriptionsQueryResult = Apollo.QueryResult<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>;
export const CancellationReasonsDocument = gql`
    query cancellationReasons($id: ID!) {
  subscription(ID: $id) {
    id
    cancellationId
    endAt
  }
  subscriptionCancellationReasons {
    displayName
    reasonCode
    orderId
  }
}
    `;

/**
 * __useCancellationReasonsQuery__
 *
 * To run a query within a React component, call `useCancellationReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationReasonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancellationReasonsQuery(baseOptions: Apollo.QueryHookOptions<CancellationReasonsQuery, CancellationReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationReasonsQuery, CancellationReasonsQueryVariables>(CancellationReasonsDocument, options);
      }
export function useCancellationReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationReasonsQuery, CancellationReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationReasonsQuery, CancellationReasonsQueryVariables>(CancellationReasonsDocument, options);
        }
export type CancellationReasonsQueryHookResult = ReturnType<typeof useCancellationReasonsQuery>;
export type CancellationReasonsLazyQueryHookResult = ReturnType<typeof useCancellationReasonsLazyQuery>;
export type CancellationReasonsQueryResult = Apollo.QueryResult<CancellationReasonsQuery, CancellationReasonsQueryVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($subscriptionId: Int!, $cancellationReason: String!, $extraComment: String!) {
  cancelSubscription(
    subscriptionId: $subscriptionId
    cancellationReason: $cancellationReason
    extraComment: $extraComment
  ) {
    id
    status
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      cancellationReason: // value for 'cancellationReason'
 *      extraComment: // value for 'extraComment'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ReactivateSubscriptionDocument = gql`
    mutation reactivateSubscription($subscriptionId: Int!, $itemPriceId: ID!) {
  reactivateSubscription(
    subscriptionId: $subscriptionId
    itemPriceId: $itemPriceId
  ) {
    id
    status
  }
}
    `;
export type ReactivateSubscriptionMutationFn = Apollo.MutationFunction<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;

/**
 * __useReactivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionMutation, { data, loading, error }] = useReactivateSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      itemPriceId: // value for 'itemPriceId'
 *   },
 * });
 */
export function useReactivateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>(ReactivateSubscriptionDocument, options);
      }
export type ReactivateSubscriptionMutationHookResult = ReturnType<typeof useReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationResult = Apollo.MutationResult<ReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export const CustomerAddressDocument = gql`
    query CustomerAddress($country: String!) {
  customerAddress(country: $country) {
    firstName
    lastName
    line1
    line2
    zip
    city
    state
    stateCode
    country
    phone
    company
  }
}
    `;

/**
 * __useCustomerAddressQuery__
 *
 * To run a query within a React component, call `useCustomerAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAddressQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCustomerAddressQuery(baseOptions: Apollo.QueryHookOptions<CustomerAddressQuery, CustomerAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerAddressQuery, CustomerAddressQueryVariables>(CustomerAddressDocument, options);
      }
export function useCustomerAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerAddressQuery, CustomerAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerAddressQuery, CustomerAddressQueryVariables>(CustomerAddressDocument, options);
        }
export type CustomerAddressQueryHookResult = ReturnType<typeof useCustomerAddressQuery>;
export type CustomerAddressLazyQueryHookResult = ReturnType<typeof useCustomerAddressLazyQuery>;
export type CustomerAddressQueryResult = Apollo.QueryResult<CustomerAddressQuery, CustomerAddressQueryVariables>;
export const AddressCountryDocument = gql`
    query AddressCountry {
  addressCountry {
    countriesRequireState
    countries {
      id
      twoLetterAbbreviation
      fullNameLocale
      availableRegions {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useAddressCountryQuery__
 *
 * To run a query within a React component, call `useAddressCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddressCountryQuery(baseOptions?: Apollo.QueryHookOptions<AddressCountryQuery, AddressCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressCountryQuery, AddressCountryQueryVariables>(AddressCountryDocument, options);
      }
export function useAddressCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressCountryQuery, AddressCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressCountryQuery, AddressCountryQueryVariables>(AddressCountryDocument, options);
        }
export type AddressCountryQueryHookResult = ReturnType<typeof useAddressCountryQuery>;
export type AddressCountryLazyQueryHookResult = ReturnType<typeof useAddressCountryLazyQuery>;
export type AddressCountryQueryResult = Apollo.QueryResult<AddressCountryQuery, AddressCountryQueryVariables>;
export const UpdateCustomerAddressDocument = gql`
    mutation UpdateCustomerAddress($firstName: String!, $lastName: String!, $line1: String!, $line2: String, $city: String!, $country: String!, $zip: String!, $stateCode: String, $company: String, $subscriptionIntentId: ID!) {
  updateAddress(
    input: {firstName: $firstName, lastName: $lastName, address: {firstName: $firstName, lastName: $lastName, line1: $line1, line2: $line2, city: $city, country: $country, zip: $zip, stateCode: $stateCode, company: $company}}
    subscriptionIntentId: $subscriptionIntentId
  ) {
    id
    email
    firstName
    lastName
    address {
      line1
      zip
      city
      country
      stateCode
      state
      company
    }
  }
}
    `;
export type UpdateCustomerAddressMutationFn = Apollo.MutationFunction<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;

/**
 * __useUpdateCustomerAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAddressMutation, { data, loading, error }] = useUpdateCustomerAddressMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      zip: // value for 'zip'
 *      stateCode: // value for 'stateCode'
 *      company: // value for 'company'
 *      subscriptionIntentId: // value for 'subscriptionIntentId'
 *   },
 * });
 */
export function useUpdateCustomerAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>(UpdateCustomerAddressDocument, options);
      }
export type UpdateCustomerAddressMutationHookResult = ReturnType<typeof useUpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationResult = Apollo.MutationResult<UpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;
export const CreateSubscriptionCustomerDocument = gql`
    mutation CreateSubscriptionCustomer($language: Language!, $email: String!, $firstName: String!, $lastName: String!, $company: String, $line1: String!, $line2: String, $city: String!, $country: String!, $zip: String!, $stateCode: String) {
  createCustomer(
    input: {language: $language, email: $email, firstName: $firstName, lastName: $lastName, address: {firstName: $firstName, lastName: $lastName, line1: $line1, line2: $line2, city: $city, country: $country, zip: $zip, stateCode: $stateCode, company: $company}}
  ) {
    id
    email
    firstName
    lastName
    address {
      line1
      zip
      city
      country
      stateCode
      state
      company
    }
  }
}
    `;
export type CreateSubscriptionCustomerMutationFn = Apollo.MutationFunction<CreateSubscriptionCustomerMutation, CreateSubscriptionCustomerMutationVariables>;

/**
 * __useCreateSubscriptionCustomerMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCustomerMutation, { data, loading, error }] = useCreateSubscriptionCustomerMutation({
 *   variables: {
 *      language: // value for 'language'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      company: // value for 'company'
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      zip: // value for 'zip'
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useCreateSubscriptionCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionCustomerMutation, CreateSubscriptionCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionCustomerMutation, CreateSubscriptionCustomerMutationVariables>(CreateSubscriptionCustomerDocument, options);
      }
export type CreateSubscriptionCustomerMutationHookResult = ReturnType<typeof useCreateSubscriptionCustomerMutation>;
export type CreateSubscriptionCustomerMutationResult = Apollo.MutationResult<CreateSubscriptionCustomerMutation>;
export type CreateSubscriptionCustomerMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionCustomerMutation, CreateSubscriptionCustomerMutationVariables>;
export const GetSubscriptionDocument = gql`
    query GetSubscription($id: ID!) {
  subscription(ID: $id) {
    status
    id
    itemPriceId
    name
    amount
    currencyCode
    customerId
    coupon {
      code
      period
      periodUnit
    }
    billingPeriodUnit
    billingPeriod
    currentTermStart
    currentTermEnd
    dueSince
    dueInvoicesCount
    nextBillingAt
    paymentMethodType
    currencyCode
    createdAt
    canReactivate
    cancellationId
    deleted
    hasScheduledChanges
    __typename
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const ApplyCouponDocument = gql`
    mutation ApplyCoupon($subscriptionIntentId: ID!, $couponCode: String!) {
  applySubscriptionCoupon(
    subscriptionIntentId: $subscriptionIntentId
    couponCode: $couponCode
  ) {
    id
    actionType
    activatedAt
    couponApplied
    coupon {
      code
      periodUnit
      period
      includeTrialPeriod
      discountPercentage
    }
  }
}
    `;
export type ApplyCouponMutationFn = Apollo.MutationFunction<ApplyCouponMutation, ApplyCouponMutationVariables>;

/**
 * __useApplyCouponMutation__
 *
 * To run a mutation, you first call `useApplyCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponMutation, { data, loading, error }] = useApplyCouponMutation({
 *   variables: {
 *      subscriptionIntentId: // value for 'subscriptionIntentId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useApplyCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponMutation, ApplyCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponMutation, ApplyCouponMutationVariables>(ApplyCouponDocument, options);
      }
export type ApplyCouponMutationHookResult = ReturnType<typeof useApplyCouponMutation>;
export type ApplyCouponMutationResult = Apollo.MutationResult<ApplyCouponMutation>;
export type ApplyCouponMutationOptions = Apollo.BaseMutationOptions<ApplyCouponMutation, ApplyCouponMutationVariables>;
export const CreatePaymentIntentDocument = gql`
    mutation CreatePaymentIntent($amount: Int!, $subscriptionIntentId: ID!, $paymentMethodType: PaymentMethodType!) {
  createPaymentIntent(
    amount: $amount
    subscriptionIntentId: $subscriptionIntentId
    paymentMethodType: $paymentMethodType
  ) {
    paymentIntent {
      id
      status
      amount
      currencyCode
      expiresAt
      paymentMethodType
    }
    paymentIntentRaw {
      id
      status
      amount
      gateway_account_id
      expires_at
      payment_method_type
      created_at
      modified_at
      updated_at
      resource_version
      object
      customer_id
      currency_code
      gateway
      business_entity_id
    }
  }
}
    `;
export type CreatePaymentIntentMutationFn = Apollo.MutationFunction<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;

/**
 * __useCreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = useCreatePaymentIntentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      subscriptionIntentId: // value for 'subscriptionIntentId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useCreatePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, options);
      }
export type CreatePaymentIntentMutationHookResult = ReturnType<typeof useCreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationResult = Apollo.MutationResult<CreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($subscriptionIntentId: ID!) {
  createSubscription(subscriptionIntentId: $subscriptionIntentId) {
    id
    name
    amount
    currencyCode
    billingPeriodUnit
    card {
      brand
      expiryMonth
      expiryYear
      last4
      maskedNumber
    }
    address {
      firstName
      lastName
      line1
      line2
      city
      stateCode
      state
      zip
      country
      vatNumber
      company
      phone
    }
    currencyCode
    currentTermEnd
    currentTermStart
    remainingBillingCycles
    createdAt
    startedAt
    updatedAt
    status
    totalDues
    deleted
    dueSince
    dueInvoicesCount
    nextBillingAt
    paymentMethodType
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      subscriptionIntentId: // value for 'subscriptionIntentId'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CreateSubscriptionIntentDocument = gql`
    mutation CreateSubscriptionIntent($itemPriceId: ID!, $licensedProductId: Int!) {
  createSubscriptionIntent(
    itemPriceId: $itemPriceId
    licensedProductId: $licensedProductId
  ) {
    id
    actionType
    name
    amount
    currencyCode
    billingPeriodUnit
    trialPeriod
    planId
    card {
      brand
      expiryMonth
      expiryYear
      last4
      maskedNumber
    }
    address {
      firstName
      lastName
      line1
      line2
      city
      stateCode
      state
      zip
      country
      vatNumber
      company
      phone
    }
    currencyCode
    currentTermEnd
    currentTermStart
    remainingBillingCycles
    createdAt
    startedAt
    updatedAt
    status
    totalDues
    deleted
    dueSince
    dueInvoicesCount
    nextBillingAt
  }
}
    `;
export type CreateSubscriptionIntentMutationFn = Apollo.MutationFunction<CreateSubscriptionIntentMutation, CreateSubscriptionIntentMutationVariables>;

/**
 * __useCreateSubscriptionIntentMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionIntentMutation, { data, loading, error }] = useCreateSubscriptionIntentMutation({
 *   variables: {
 *      itemPriceId: // value for 'itemPriceId'
 *      licensedProductId: // value for 'licensedProductId'
 *   },
 * });
 */
export function useCreateSubscriptionIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionIntentMutation, CreateSubscriptionIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionIntentMutation, CreateSubscriptionIntentMutationVariables>(CreateSubscriptionIntentDocument, options);
      }
export type CreateSubscriptionIntentMutationHookResult = ReturnType<typeof useCreateSubscriptionIntentMutation>;
export type CreateSubscriptionIntentMutationResult = Apollo.MutationResult<CreateSubscriptionIntentMutation>;
export type CreateSubscriptionIntentMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionIntentMutation, CreateSubscriptionIntentMutationVariables>;
export const GetSubscriptionIntentDocument = gql`
    query GetSubscriptionIntent($id: ID!) {
  subscriptionIntent(id: $id) {
    id
    actionType
    name
    amount
    currencyCode
    customerId
    coupon {
      code
      discountPercentage
      period
      periodUnit
      includeTrialPeriod
    }
    billingPeriodUnit
    billingPeriod
    trialPeriod
    trialPeriodUnit
    planId
    image
    card {
      brand
      expiryMonth
      expiryYear
      last4
      maskedNumber
    }
    address {
      firstName
      lastName
      line1
      line2
      city
      stateCode
      state
      zip
      country
      vatNumber
      company
      phone
    }
    currencyCode
    currentTermEnd
    currentTermStart
    remainingBillingCycles
    createdAt
    startedAt
    updatedAt
    status
    totalDues
    deleted
    dueSince
    dueInvoicesCount
    nextBillingAt
    subscriptionId
    paymentIntentId
    paymentMethodType
    paymentSourceId
  }
}
    `;

/**
 * __useGetSubscriptionIntentQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionIntentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionIntentQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionIntentQuery, GetSubscriptionIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionIntentQuery, GetSubscriptionIntentQueryVariables>(GetSubscriptionIntentDocument, options);
      }
export function useGetSubscriptionIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionIntentQuery, GetSubscriptionIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionIntentQuery, GetSubscriptionIntentQueryVariables>(GetSubscriptionIntentDocument, options);
        }
export type GetSubscriptionIntentQueryHookResult = ReturnType<typeof useGetSubscriptionIntentQuery>;
export type GetSubscriptionIntentLazyQueryHookResult = ReturnType<typeof useGetSubscriptionIntentLazyQuery>;
export type GetSubscriptionIntentQueryResult = Apollo.QueryResult<GetSubscriptionIntentQuery, GetSubscriptionIntentQueryVariables>;
export const RelatedPlansDocument = gql`
    query RelatedPlans($subscriptionId: ID!) {
  subscription(ID: $subscriptionId) {
    id
    billingPeriodUnit
    address {
      country
    }
    relatedPlans {
      id
      name
      family
      licensedProductId
      enabledForCheckout
      sku
      systemName
      description
      status
      features
      yearMonthPrice {
        monthlyPrice
        percentSaved
        amountSaved
      }
      offerType
      prices {
        name
        id
        period
        periodUnit
        price
        systemName
        currency
      }
    }
  }
}
    `;

/**
 * __useRelatedPlansQuery__
 *
 * To run a query within a React component, call `useRelatedPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedPlansQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useRelatedPlansQuery(baseOptions: Apollo.QueryHookOptions<RelatedPlansQuery, RelatedPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedPlansQuery, RelatedPlansQueryVariables>(RelatedPlansDocument, options);
      }
export function useRelatedPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedPlansQuery, RelatedPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedPlansQuery, RelatedPlansQueryVariables>(RelatedPlansDocument, options);
        }
export type RelatedPlansQueryHookResult = ReturnType<typeof useRelatedPlansQuery>;
export type RelatedPlansLazyQueryHookResult = ReturnType<typeof useRelatedPlansLazyQuery>;
export type RelatedPlansQueryResult = Apollo.QueryResult<RelatedPlansQuery, RelatedPlansQueryVariables>;